import React from "react";
import { FaArrowRight } from "react-icons/fa6";
import { Container } from "../home/ui";

// Banner background (store on a phone, cart and bags on the right; rounded corners are part of the image).
// File: public/img/ecommerce-cta.jpg (2548x758). Used on desktop only (via the --cta-bg CSS variable) so it is
// never stretched; smaller screens get the soft purple gradient.
const ctaBg = "/img/ecommerce-cta.jpg";

const EcomCta = () => (
  <section className="bg-white pb-[24px] pt-[16px] lg:pb-[40px]">
    <Container className="max-w-[1320px]">
      <div
        className="relative overflow-hidden rounded-[22px] bg-gradient-to-r from-[#F7F5FF] via-[#F1EDFF] to-[#E9E3FF] px-[24px] py-[32px] sm:px-[40px] lg:flex lg:aspect-[2548/758] lg:items-center lg:rounded-[2.2%/7.4%] lg:bg-[image:var(--cta-bg)] lg:bg-[length:100%_100%] lg:bg-no-repeat lg:px-[5.5%] lg:py-0"
        style={{ "--cta-bg": `url(${ctaBg})` }}
      >
        {/* Text stays on the empty left half of the artwork */}
        <div className="lg:max-w-[48%]">
          <h2 className="text-[26px] font-bold leading-[1.25] tracking-tight text-[#0B0D2C] sm:text-[32px] lg:text-[clamp(24px,2.3vw,36px)]">
            Ready to Build Your
            <br />
            E-commerce Store?
          </h2>
          <p className="mt-[12px] max-w-[460px] text-[15px] leading-[1.6] text-slate-600 sm:text-[16px] lg:mt-[clamp(8px,0.8vw,14px)] lg:text-[clamp(13px,1.05vw,17px)]">
            Let&apos;s create a high-performing online store that helps you reach more customers and increase your sales.
          </p>
          <a
            href="/contact-us"
            className="group mt-[24px] inline-flex h-[50px] items-center gap-[10px] rounded-full bg-gradient-to-r from-[#0EA5FF] via-[#3D5BF6] to-[#8B2CF5] px-[26px] text-[15px] font-medium text-white shadow-[0_14px_30px_-14px_rgba(91,61,245,0.7)] transition hover:brightness-110 lg:mt-[clamp(14px,1.5vw,26px)] lg:h-[clamp(42px,3.3vw,52px)] lg:text-[clamp(13px,1vw,15.5px)]"
          >
            Get a Free Consultation
            <FaArrowRight className="text-[13px] transition group-hover:translate-x-1" />
          </a>
        </div>
      </div>
    </Container>
  </section>
);

export default EcomCta;
